import React, { useState } from 'react';
import PropTypes from 'prop-types';
import TextBoxGroup from '../text-box-group/text-box-group';
import Button from '../button/button';
import { AcceptIcon, EditIcon } from '../icons/icons';

function TitleEditable({ value, onChange, placeholder }) {
  const [isToggle, setIsToggle] = useState(value === '');
  const [inputValue, setInputValue] = useState(value);

  const handleChange = (e) => {
    const val = e?.target?.value || '';
    setInputValue(val);
    onChange(e);
  };

  const isDisabled =
    !inputValue || inputValue?.trim() === '' || !/[a-zA-Z0-9]/.test(inputValue);

  return (
    <>
      {!isToggle && <h4 className="text-limit mw-200">{inputValue} </h4>}
      {isToggle && (
        <TextBoxGroup
          className="mb-0"
          name="newPackage"
          placeholder={placeholder}
          type="text"
          defaultValue={inputValue}
          onChange={handleChange}
          onBlur={() => setIsToggle(true)}
          autoFocus
        />
      )}
      {!isToggle ? (
        <Button
          styles="icon"
          className="px-10"
          icon={<EditIcon size="1.25vw" color="#0288FA" />}
          onClick={() => setIsToggle(true)}
        />
      ) : (
        <Button
          styles="icon"
          className="px-10"
          icon={<AcceptIcon size="1.25vw" color="#0288FA" />}
          onClick={() => setIsToggle(false)}
          disabled={isDisabled}
        />
      )}
    </>
  );
}

export default TitleEditable;
TitleEditable.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
};
TitleEditable.defaultProps = {
  value: '',
  onChange: () => {},
  placeholder: '',
};
